import { useQuery } from '@tanstack/react-query';
import api from '@/services/api';
import { useTerritoryStore } from '@/stores/territoryStore';
import type { Territory, TerritoryWithGeometry } from '@/types/territory';

export function useTerritories() {
  return useQuery<Territory[]>({
    queryKey: ['territories'],
    queryFn: async () => {
      const { data } = await api.get('/territories');
      return data;
    },
  });
}

export function useTerritory(codeInsee: string | null) {
  return useQuery<TerritoryWithGeometry>({
    queryKey: ['territory', codeInsee],
    queryFn: async () => {
      const { data } = await api.get(`/territories/${codeInsee}`);
      return data;
    },
    enabled: !!codeInsee,
  });
}

export function useActiveTerritory() {
  const { activeTerritory, setActiveTerritory } = useTerritoryStore();
  return { activeTerritory, setActiveTerritory };
}
